import { defineStore } from 'pinia'
import { ref } from 'vue'
import sortWith from 'ramda/es/sortWith'
import ascend from 'ramda/es/ascend'
import prop from 'ramda/es/prop'
import { loadPiniaSlice, persistPiniaSlice } from '../persist'
import { scheduleTestSessionPatch } from '../testSession'

const sortByPosition = sortWith([ascend(prop('position'))])

export const useMainCategoriesStore = defineStore('mainCategories', () => {
    const allMainCategories = ref([])
    const selectedCategory = ref('')
    const selectedCategories = ref([])

    const findById = (id) => allMainCategories.value.find((c) => c.id == id)

    const selectCategory = (category) => {
        selectedCategory.value = category
        persistToLocalStorage()
    }

    const selectCategoryById = (id) => {
        selectedCategory.value = findById(id)
        persistToLocalStorage()
    }

    const setSelectedCategories = (categories) => {
        selectedCategories.value = sortByPosition(categories)
        persistToLocalStorage()
    }

    const setAllMainCategories = (categories) => {
        allMainCategories.value = sortByPosition(categories)
        persistToLocalStorage()
    }

    const persistToLocalStorage = () => {
        persistPiniaSlice('mainCategoriesStore', {
            selectedCategory: selectedCategory.value,
            selectedCategories: selectedCategories.value,
        })
        scheduleTestSessionPatch({
            allMainCategories: allMainCategories.value,
            selectedCategory: selectedCategory.value,
            selectedCategories: selectedCategories.value,
        })
    }

    const hydrateCatalog = (session) => {
        if (Array.isArray(session.allMainCategories)) {
            allMainCategories.value = session.allMainCategories
        }
        if (session.selectedCategory !== undefined && !selectedCategory.value) {
            selectedCategory.value = session.selectedCategory
        }
        if (Array.isArray(session.selectedCategories) && selectedCategories.value.length === 0) {
            selectedCategories.value = session.selectedCategories
        }
    }

    const loadFromLocalStorage = () => {
        const stored = loadPiniaSlice('mainCategoriesStore')
        if (!stored) return
        if (stored.selectedCategory !== undefined) {
            selectedCategory.value = stored.selectedCategory
        }
        if (Array.isArray(stored.selectedCategories)) {
            selectedCategories.value = stored.selectedCategories
        }
    }

    loadFromLocalStorage()

    return {
        allMainCategories,
        selectedCategory,
        selectedCategories,
        findById,
        selectCategory,
        selectCategoryById,
        setSelectedCategories,
        setAllMainCategories,
        hydrateCatalog,
    }
})
